import { GuestNav } from "../chrome/guest-nav.js";
import { Ring } from "../chrome/ring.js";
import type { ViewPhoto } from "../photos.js";
import { PHOTO_QUOTA } from "../types.js";

export interface GalleryScreenProps {
  readonly mine: readonly ViewPhoto[];
  readonly left: number;
  readonly accent: string;
}

export function GalleryScreen({ mine, left, accent }: GalleryScreenProps) {
  return (
    <div class="d-screen d-scroll d-guest-page" data-theme="dark" data-testid="screen-gallery">
      <header class="d-gallery-head">
        <div>
          <h1 class="d-card-title">Suas fotos</h1>
          <p class="d-caption">Só você vê esta tela</p>
        </div>
        <span class="d-ring-chip is-plain">
          <Ring size={34} stroke={3} fraction={left / PHOTO_QUOTA} color={accent}>
            {left}
          </Ring>
          <span>{left === 1 ? "foto restante" : "fotos restantes"}</span>
        </span>
      </header>
      <section class="d-gallery-body">
        <p class="d-section-title">
          <span>Enviadas</span>
          <span>{mine.length}</span>
        </p>
        {mine.length === 0 ? (
          <p class="d-caption" data-testid="gallery-empty">
            Suas fotos publicadas aparecem aqui
          </p>
        ) : (
          <div class="d-grid3">
            {mine.map((photo) => (
              <img key={photo.id} class="d-tile" src={photo.small} alt="Sua foto" />
            ))}
          </div>
        )}
      </section>
      <GuestNav active="galeria" />
    </div>
  );
}
